import React, { useState } from 'react'
import { IonModal, IonContent } from '@ionic/react'
import styled from '@emotion/styled'
import { useDispatch } from 'react-redux'
import { authActions } from './AuthStore'
import { TextFieldInput } from '../common/TextField'
import { Button } from '../components'
import aplicacaoPadrao from '../assets/marca/aplicacao_padrao.png'
import { toast } from 'react-toastify'
import axiosApi from '../common/axios'

export function DefinirSenha() {
  const { Container, ContainerInterno, ImgMarca, Titulo, Subtitulo, ContainerBotao, LinkDispensa, ErroInline } = DefinirSenha
  const dispatch = useDispatch()
  const [novaSenha, setNovaSenha] = useState('')
  const [confirmaSenha, setConfirmaSenha] = useState('')
  const [erroValidacao, setErroValidacao] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (novaSenha.length < 6) return setErroValidacao('A senha precisa ter pelo menos 6 caracteres')
    if (novaSenha !== confirmaSenha) return setErroValidacao('As senhas não coincidem')
    setErroValidacao('')
    setLoading(true)
    try {
      await axiosApi.Usuarios.definirSenha(novaSenha)
      dispatch(authActions.passwordDefined())
    } catch (error: any) {
      toast(error.response?.data?.message || 'Erro ao definir senha')
    } finally {
      setLoading(false)
    }
  }

  function handleDismiss() {
    dispatch(authActions.passwordDefined())
  }

  return (
    <IonModal isOpen={true} backdropDismiss={false}>
      <IonContent>
        <Container>
          <ContainerInterno>
            <ImgMarca>
              <img src={aplicacaoPadrao} alt="" />
            </ImgMarca>
            <Titulo>Defina sua senha</Titulo>
            <Subtitulo>Por segurança, crie uma senha pessoal para continuar</Subtitulo>
            <form onSubmit={handleSubmit} style={{ marginTop: 28 }}>
              <TextFieldInput
                value={novaSenha}
                onChange={(e) => setNovaSenha((e.target as HTMLInputElement).value)}
                type="password"
                placeholder="Nova senha"
              />
              <TextFieldInput
                value={confirmaSenha}
                onChange={(e) => setConfirmaSenha((e.target as HTMLInputElement).value)}
                type="password"
                placeholder="Confirme a nova senha"
              />
              {erroValidacao && <ErroInline>{erroValidacao}</ErroInline>}
              <ContainerBotao>
                <Button type="submit" loading={loading} label="Definir senha" />
              </ContainerBotao>
            </form>
            <LinkDispensa onClick={handleDismiss}>Continuar sem alterar</LinkDispensa>
          </ContainerInterno>
        </Container>
      </IonContent>
    </IonModal>
  )
}

DefinirSenha.Container = styled.div`
  max-width: 661px;
  margin: 34px auto;
  background: #ffffff;
  box-shadow: 0px 4px 16px rgba(51, 51, 51, 0.08);
  padding: 28px 0;
  @media (max-width: 689px) {
    margin: 0;
    width: 100%;
    max-width: 100%;
    min-height: 100vh;
    padding: 12px;
  }
`
DefinirSenha.ContainerInterno = styled.div`
  max-width: 400px;
  margin: 0 auto;
`
DefinirSenha.ImgMarca = styled.div`
  width: 147px;
  margin: 0 auto;
  display: block;
  margin-bottom: 48px;
`
DefinirSenha.Titulo = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  margin-top: 48px;
`
DefinirSenha.Subtitulo = styled.div`
  font-size: 18px;
  color: #000000;
  margin-top: 8px;
`
DefinirSenha.ContainerBotao = styled.div`
  margin-top: 28px;
  button {
    margin: 0 auto;
  }
`
DefinirSenha.ErroInline = styled.div`
  color: red;
  font-size: 13px;
  margin-bottom: 8px;
`
DefinirSenha.LinkDispensa = styled.div`
  text-align: center;
  margin-top: 24px;
  font-size: 14px;
  color: #828282;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`
